import { Input } from "@/components/ui/input";

export const DOMAINS = ["personality", "strengths", "challenges", "communication", "learning", "relationships", "love_language", "gifts", "motivation", "spiritual", "life_purpose", "life_lessons", "other"];
export const FEATURE_TYPES = ["first_letter", "first_vowel", "last_letter", "middle_letter", "letter", "consonant_cluster", "vowel_group", "combination", "double_letter", "repeated_letter", "initial", "structure"];
export const STRUCTURES = ["first_is_full", "first_is_initials", "single_initial", "multiple_initials", "no_middle_name", "one_middle_name", "multiple_middle_names", "no_family_name", "compound_family_name", "hyphenated_part", "contains_diacritics"];

export const PageTitle = ({ title, sub, children }) => (
  <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
    <div>
      <h1 className="font-serif-display text-3xl sm:text-4xl" data-testid="admin-page-title">{title}</h1>
      {sub && <p className="mt-1 max-w-2xl text-sm text-muted-foreground">{sub}</p>}
    </div>
    <div className="flex flex-wrap gap-2">{children}</div>
  </div>
);

export const Panel = ({ title, children, className = "", testId }) => (
  <section className={`rounded-md border border-border bg-card p-5 ${className}`} data-testid={testId}>
    {title && <h2 className="mb-4 font-mono-ui text-xs uppercase tracking-[0.2em] text-muted-foreground">{title}</h2>}
    {children}
  </section>
);

const BADGE = {
  approved: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  done: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  running: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  failed: "bg-red-500/15 text-red-400 border-red-500/30",
  selected: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  draft: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  rejected: "bg-red-500/15 text-red-400 border-red-500/30",
  excluded: "bg-red-500/15 text-red-400 border-red-500/30",
  overridden: "bg-red-500/15 text-red-400 border-red-500/30",
  consolidated: "bg-sky-500/15 text-sky-300 border-sky-500/30",
  archived: "bg-zinc-500/15 text-zinc-400 border-zinc-500/30",
};
export const StatusBadge = ({ s }) => (
  <span className={`inline-block rounded border px-2 py-0.5 font-mono-ui text-[10px] uppercase tracking-wider ${BADGE[s] || "border-border text-muted-foreground"}`}>{s}</span>
);

export const Btn = ({ variant = "primary", className = "", ...p }) => (
  <button
    {...p}
    className={`inline-flex items-center gap-2 rounded px-4 py-2 text-sm font-medium transition-colors disabled:opacity-40 ${
      variant === "primary" ? "bg-primary text-primary-foreground hover:bg-primary/85" : variant === "danger" ? "border border-red-500/40 text-red-400 hover:bg-red-500/10" : "border border-border text-foreground hover:bg-secondary"
    } ${className}`}
  />
);

export const Sel = ({ value, onChange, options, testId, className = "" }) => (
  <select value={value} onChange={(e) => onChange(e.target.value)} data-testid={testId} className={`h-9 rounded border border-input bg-background px-2 text-sm ${className}`}>
    {options.map((o) => (Array.isArray(o) ? <option key={o[0]} value={o[0]}>{o[1]}</option> : <option key={o} value={o}>{o}</option>))}
  </select>
);

export const emptyName = { first: "", first_type: "auto", middles: "", surname: "", no_surname: false };
export const toNamePayload = (n) => ({ first: n.first, first_type: n.first_type, middles: n.middles.split(",").map((m) => m.trim()).filter(Boolean), surname: n.surname || null, no_surname: n.no_surname });

export const NameFields = ({ n, setN, prefix = "qc" }) => (
  <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-5">
    <Input placeholder="First name / initials" value={n.first} onChange={(e) => setN({ ...n, first: e.target.value })} data-testid={`${prefix}-first-input`} />
    <Sel value={n.first_type} onChange={(v) => setN({ ...n, first_type: v })} options={[["auto", "Auto-detect"], ["full", "Full first name"], ["initials", "Initials"]]} testId={`${prefix}-first-type-select`} />
    <Input placeholder="Middle names (comma-separated)" value={n.middles} onChange={(e) => setN({ ...n, middles: e.target.value })} data-testid={`${prefix}-middles-input`} />
    <Input placeholder="Family name" value={n.surname} disabled={n.no_surname} onChange={(e) => setN({ ...n, surname: e.target.value })} data-testid={`${prefix}-surname-input`} />
    <label className="flex items-center gap-2 text-sm text-muted-foreground">
      <input type="checkbox" checked={n.no_surname} onChange={(e) => setN({ ...n, no_surname: e.target.checked })} data-testid={`${prefix}-no-surname-checkbox`} /> No family name
    </label>
  </div>
);
